import { type CountryCallingCode, type CountryCode, parsePhoneNumberFromString } from "libphonenumber-js";

import { getIsProd } from "../../config";

export const DEFAULT_COUNTRY_CODE: CountryCode = "US";

export const validatePhoneNumber = (
    mdn: string | undefined,
    defaultCountry: CountryCode = DEFAULT_COUNTRY_CODE,
    skipValidation: boolean = false,
): { valid: boolean; number?: string; countryCode?: CountryCallingCode } => {
    if (!mdn) {
        return { valid: false };
    }
    const parsed = mdn.startsWith("+")
        ? parsePhoneNumberFromString(mdn)
        : parsePhoneNumberFromString(mdn, { defaultCountry });
    if (!parsed) {
        return { valid: false };
    }
    const isValid = getIsProd() && !skipValidation ? parsed.isValid() : parsed.isPossible();
    return { valid: isValid, number: parsed.number, countryCode: parsed.countryCallingCode };
};

/**
 * True when `mdn` parses to a country other than US.
 *
 * Called without a default region, so only an E.164 number (`+44…`) resolves a country; a bare
 * national number does not parse and returns false. Callers pass the inbound ANI, which Amazon
 * Connect supplies in E.164.
 */
export const isInternationalCaller = (mdn: string | undefined): boolean => {
    if (!mdn) {
        return false;
    }
    const parsed = parsePhoneNumberFromString(mdn);
    if (!parsed) {
        return false;
    }
    return parsed.country !== "US";
};
